import { ajouterJours, lundiCourant } from "../semaine-dates";

/**
 * Les lundis du planning, en UTC sur des textes AAAA-MM-JJ : jamais le fuseau de la machine. Ce sont les fonctions de
 * `semaine-dates.ts` (celles de la diffusion), sous les noms du plan.
 */

/** Le lundi (AAAA-MM-JJ) de la semaine du jour de Paris de `date`. */
export function lundiDe(date: Date): string {
  return lundiCourant(date);
}

export function lundiSuivant(lundi: string): string {
  return ajouterJours(lundi, 7);
}

export function lundiPrecedent(lundi: string): string {
  return ajouterJours(lundi, -7);
}
